module.exports = "/_next/static/images/hu-b95aa09ee3425cd425a8d875cfddd5dc.svg";